import React from "react";
import { Icon } from "../core/icon";
import Close from '@mui/icons-material/Close';
import CloseFullscreen from '@mui/icons-material/CloseFullscreen';
import GitHub from "@mui/icons-material/GitHub";
import HiveOutlined from '@mui/icons-material/HiveOutlined';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import NoteAdd from '@mui/icons-material/NoteAdd';
import OpenInNew from "@mui/icons-material/OpenInNew";
import { Brush, ErrorOutline, FormatColorFill, PanTool, PanToolAlt, RedoOutlined, UndoOutlined, WarningAmber } from "@mui/icons-material";
import { Eraser } from "./icons/eraser";
import { DrawRect } from "./icons/drawRect";
const SUPPORTED_ICONS = {
    [Icon.NEW_RESOURCE]: NoteAdd,
    [Icon.CLOSE]: Close,
    [Icon.COLLAPSE_ALL]: CloseFullscreen,
    [Icon.DRAWER_CLOSE]: KeyboardDoubleArrowLeftIcon,
    [Icon.DRAWER_OPEN]: KeyboardDoubleArrowRightIcon,
    [Icon.ERROR]: ErrorOutline,
    [Icon.EXTERNAL_LINK]: OpenInNew,
    [Icon.GITHUB]: GitHub,
    [Icon.HEXMAP_ICON]: HiveOutlined,
    [Icon.INFO]: InfoOutlineIcon,
    [Icon.TOOL_BRUSH]: Brush,
    [Icon.TOOL_DRAW_RECT]: DrawRect,
    [Icon.TOOL_ERASE]: Eraser,
    [Icon.TOOL_FILL]: FormatColorFill,
    [Icon.TOOL_PAN]: PanTool,
    [Icon.TOOL_POINT_CLICK]: PanToolAlt,
    [Icon.REDO]: RedoOutlined,
    [Icon.UNDO]: UndoOutlined,
    [Icon.WARNING]: WarningAmber,
};
export const renderIcon = (icon, props) => {
    const IconComponent = SUPPORTED_ICONS[icon];
    return React.createElement(IconComponent, { ...props });
};
export const optionallyRenderIcon = (icon, props) => (icon ? renderIcon(icon, props) : null);
//# sourceMappingURL=renderIcon.js.map